import { render, staticRenderFns } from "./longProducts.vue?vue&type=template&id=13645f60&scoped=true"
import script from "./longProducts.vue?vue&type=script&lang=js"
export * from "./longProducts.vue?vue&type=script&lang=js"
import style0 from "./longProducts.vue?vue&type=style&index=0&id=13645f60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13645f60",
  null
  
)

export default component.exports